/**
 * @generated SignedSource<<58786830d760e2135318075153eda08e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateInvitationPayload",
    "kind": "LinkedField",
    "name": "createInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InvitationEdge",
        "kind": "LinkedField",
        "name": "invitationEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Invitation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTeamInviteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateTeamInviteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5dd52ca46388adf246e8c932e953eb80",
    "id": null,
    "metadata": {},
    "name": "CreateTeamInviteMutation",
    "operationKind": "mutation",
    "text": "mutation CreateTeamInviteMutation(\n  $input: CreateInvitationInput!\n) {\n  createInvitation(input: $input) {\n    invitationEdge {\n      node {\n        id\n        kind\n        email\n        url\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "744fc8a8330e8308baa727041b508ac5";

export default node;
